var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowDownFig = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74887 10.7346C4.12261 10.0974 4.58261 9.02136 5.47595 9.03376L5.91864 9.03991C6.17346 9.04345 6.41731 9.14414 6.60039 9.32141L13.0079 15.5258C13.4092 15.9144 13.4143 16.5563 13.0194 16.9513L12.643 17.3276C12.2501 17.7206 11.6122 17.7178 11.2227 17.3215L4.74887 10.7346Z",
    fill: "#2A2A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4728 9.2751C17.6586 9.09848 17.9052 9 18.1616 9L18.5859 9C19.4768 9 19.923 10.0771 19.293 10.7071L12.6664 17.3338C12.2758 17.7243 11.6427 17.7243 11.2521 17.3338L10.8764 16.9581C10.4789 16.5605 10.4871 15.9134 10.8947 15.5261L17.4728 9.2751Z",
    fill: "#2A2A2A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDownFig, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-down-fig.9616486d.svg";
export { ForwardRef as ReactComponent };